<template>
  <div
    tabindex="0"
    class="fip-casting-detail"
    @click="onClickPerson">
    <div
      v-if="resizedImage"
      class="image">
      <img
        :src="resizedImage"
        :alt="name"
        width="170"
        height="170">
    </div>
    <div
      v-else
      class="no-image">
      <wptv-icon
        name="person-default"
        width="100%"
        height="100%" />
    </div>

    <div class="name">
      {{ name }}
    </div>
    <div class="cast">
      {{ isDirector ? $t('fip.casting.author') : person.character || '' }}
    </div>
  </div>
</template>

<script>
import { WptvIcon } from '@wptv/components/ui/icon'
import _get from 'lodash/get'
import { setItemImageData } from '../../../../shared/imageData.utils'

export default {
  name: 'FipCastingDetail',
  components: {
    WptvIcon
  },
  props: {
    person: {
      type: Object,
      required: true
    },
    isDirector: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    name () {
      return [this.person.firstName, this.person.lastName].filter(Boolean).join(' ')
    },
    resizedImage () {
      if ((this.person.covers && this.person.covers.length > 0) || (this.person.images && this.person.images.length > 0)) {
        const imageData = setItemImageData(this.person, {}, this.$config)

        const url = new URL(imageData.image.url)
        url.searchParams.append('format', this.$config.confetti.public.actorsImagesFormat)
        url.searchParams.append('facedetect', this.$config.confetti.public.actorsImagesFaceDetect)
        url.searchParams.append('saveas', 'webp')
        url.searchParams.append('saveasquality', '50')

        return url.href
      }

      return null
    }
  },
  methods: {
    onClickPerson () {
      const url = new URL(`${_get(this.$config, 'confetti.public.urls.searchUrl')}${this.name}`)
      window.open(url.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
  .fip-casting-detail {
    @extend %focus-visible;

    .no-image,
    .image {
      @include mediaQueries('width', (xsmall: 117px, medium: 157px, large: 170px));
      @include mediaQueries('height', (xsmall: 117px, medium: 157px, large: 170px));
      transition: filter 0.5s ease-in-out;
    }

    .image {
      display: flex;
      justify-content: center;

      img {
        border-radius: 50%;
      }
    }

    .name, .cast {
      @include mediaQueries('font-size', (xsmall: 16px, large: 18px));
      @include mediaQueries('line-height', (xsmall: 1.38, large: 1.33));
      text-align: center;
      margin: 6px 0 0 0;
      white-space: initial;
    }

    .name {
      font-weight: bold;
    }

    .cast {
      color: $middlegrey;
    }

    &:hover {
      .name {
        text-decoration: underline;
        text-decoration-color: $primary;
      }

      .image,
      .no-image {
        filter: brightness(70%);
      }
    }
  }
</style>
